import { createRoute } from "@tanstack/react-router";
import { RootRoute } from "../root-route";
import { SiteHeader } from "@/components/site-header";
import { SiteFooter } from "@/components/site-footer";

export const AboutRoute = createRoute({
  getParentRoute: () => RootRoute,
  path: "/om",
  component: About,
  head: () => ({
    meta: [
      { title: "Om Bevattningskartan" },
      { name: "description", content: "Om Bevattningskartan - en oberoende översikt över bevattningsförbud i Sverige." },
    ],
    links: [
      { rel: "canonical", href: "https://bevattningskartan.se/om" },
    ],
  }),
});

function About() {
  return (
    <div className="min-h-screen bg-background">
      <SiteHeader />
      <main className="mx-auto max-w-6xl px-4 py-10 sm:px-6 sm:py-14">
        <article className="max-w-2xl">
          <h1 className="font-display text-4xl sm:text-5xl text-foreground">
            Om Bevattningskartan
          </h1>

          <p className="mt-4 text-muted-foreground">
            Under torra perioder inför kommuner och VA-aktörer ofta bevattningsförbud för att spara dricksvatten. Informationen finns men är spridd över hundratals webbplatser. Bevattningskartan samlar den på ett ställe.
          </p>

          <p className="mt-4 text-muted-foreground">
            Den här sajten ska på sikt täcka alla Sveriges VA-huvudmän och samtliga kommuner.
          </p>

          <section className="mt-10">
            <h2 className="font-display text-2xl text-foreground">Vi gissar aldrig</h2>
            <p className="mt-3 text-muted-foreground">
              Innehållet på källornas sidor läses in automatiskt och tolkas av en språkmodell. Om informationen inte kan tolkas säkert visar vi uttryckligen ingen data istället för att riskera ge fel besked. Verifiera alltid mot din kommun innan du fattar beslut.
            </p>
          </section>

          <section className="mt-8">
            <h2 className="font-display text-2xl text-foreground">Integritet</h2>
            <p className="mt-3 text-muted-foreground">
              Din position används bara i din egen webbläsare för att slå upp kommun.
            </p>
          </section>

          <section className="mt-8">
            <h2 className="font-display text-2xl text-foreground">Kontakt</h2>
            <p className="mt-3 text-muted-foreground">
              Bevattningskartan är ett oberoende projekt. Saknas din kommun? Hör av dig så lägger vi till källan.
            </p>
            <p className="mt-2">
              <a
                href="mailto:hej@bevattningskartan.se"
                className="text-primary hover:underline"
              >
                hej@bevattningskartan.se 🙂
              </a>
            </p>
          </section>
        </article>
      </main>
      <SiteFooter />
    </div>
  );
}
